module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_germany_cn.87ce526d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_germany_cn.png
// module id = 1209
// module chunks = 16